import { render, staticRenderFns } from "./traeger.vue?vue&type=template&id=21ca74e3&scoped=true&"
import script from "./traeger.vue?vue&type=script&lang=js&"
export * from "./traeger.vue?vue&type=script&lang=js&"
import style0 from "./traeger.vue?vue&type=style&index=0&id=21ca74e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ca74e3",
  null
  
)

export default component.exports